<div class="dashboard">
  <!-- Actions Bar (flush with header) -->
  <div class="dashboard__actions-bar">
    <div class="dashboard__period-selector">
      <button class="dashboard__period-btn" [class.dashboard__period-btn--active]="selectedPeriod === '7d'" (click)="changePeriod('7d')">7 Tage</button>
      <button class="dashboard__period-btn" [class.dashboard__period-btn--active]="selectedPeriod === '30d'" (click)="changePeriod('30d')">30 Tage</button>
      <button class="dashboard__period-btn" [class.dashboard__period-btn--active]="selectedPeriod === '90d'" (click)="changePeriod('90d')">90 Tage</button>
    </div>
    <button class="dashboard__refresh-btn" (click)="forceRefresh()" [disabled]="loadingOverview()">
      <i class="pi" [class.pi-refresh]="!loadingOverview()" [class.pi-spin]="loadingOverview()" [class.pi-spinner]="loadingOverview()"></i>
      <span *ngIf="!loadingOverview()">Aktualisieren</span>
      <span *ngIf="loadingOverview()">Lädt...</span>
    </button>
  </div>

  <!-- ESG Hero Card -->
  <app-esg-hero
    [score]="esgScore"
    [size]="120"
    [strokeWidth]="10"
    (cardClick)="onEsgCardClick()"
    (categoryClick)="onEsgCategoryClick($event)"
    class="dashboard__esg-hero">
  </app-esg-hero>

  <!-- KPI Cards -->
  <div class="kpi-grid">
    <!-- Revenue -->
    <div class="kpi-card kpi-card--accent">
      <div class="kpi-card__header">
        <div class="kpi-card__icon">
          <i class="pi pi-chart-line"></i>
        </div>
        <div class="kpi-card__content">
          <div class="kpi-card__value" *ngIf="!loadingOverview()">
            {{ overview?.overview?.totalRevenue ? formatCurrency(overview!.overview.totalRevenue) : '€0,00' }}
          </div>
          <div class="kpi-card__skeleton" *ngIf="loadingOverview()"></div>
          <div class="kpi-card__label">Gesamtumsatz</div>
          <div class="kpi-card__trend kpi-card__trend--up" *ngIf="!loadingOrders() && orderAnalytics">
            <i class="pi" [ngClass]="getTrendIcon(orderAnalytics.analytics.revenueTrend)"></i>
            {{ orderAnalytics.analytics.revenueTrend > 0 ? '+' : '' }}{{ orderAnalytics.analytics.revenueTrend.toFixed(1) }}%
          </div>
        </div>
      </div>
    </div>

    <!-- Business Hubs -->
    <div class="kpi-card">
      <div class="kpi-card__header">
        <div class="kpi-card__icon">
          <i class="pi pi-building"></i>
        </div>
        <div class="kpi-card__content">
          <div class="kpi-card__value" *ngIf="!loadingOverview()">
            {{ overview?.overview?.businessHubs ?? 0 }}
          </div>
          <div class="kpi-card__skeleton" *ngIf="loadingOverview()"></div>
          <div class="kpi-card__label">Business Hubs</div>
        </div>
      </div>
    </div>

    <!-- Users -->
    <div class="kpi-card">
      <div class="kpi-card__header">
        <div class="kpi-card__icon">
          <i class="pi pi-users"></i>
        </div>
        <div class="kpi-card__content">
          <div class="kpi-card__value" *ngIf="!loadingOverview()">
            {{ overview?.overview?.activeUsers ?? 0 }}
          </div>
          <div class="kpi-card__skeleton" *ngIf="loadingOverview()"></div>
          <div class="kpi-card__label">Aktive Nutzer</div>
          <div class="kpi-card__trend" [ngClass]="userAnalytics && userAnalytics.analytics.growthTrend >= 0 ? 'kpi-card__trend--up' : 'kpi-card__trend--down'" *ngIf="!loadingUsers() && userAnalytics">
            <i class="pi" [ngClass]="getTrendIcon(userAnalytics.analytics.growthTrend)"></i>
            {{ userAnalytics.analytics.growthTrend > 0 ? '+' : '' }}{{ userAnalytics.analytics.growthTrend.toFixed(1) }}%
          </div>
        </div>
      </div>
    </div>

    <!-- Orders -->
    <div class="kpi-card">
      <div class="kpi-card__header">
        <div class="kpi-card__icon">
          <i class="pi pi-shopping-cart"></i>
        </div>
        <div class="kpi-card__content">
          <div class="kpi-card__value" *ngIf="!loadingOverview()">
            {{ overview?.overview?.totalOrders ?? 0 }}
          </div>
          <div class="kpi-card__skeleton" *ngIf="loadingOverview()"></div>
          <div class="kpi-card__label">Bestellungen</div>
        </div>
      </div>
    </div>

    <!-- Posts -->
    <div class="kpi-card">
      <div class="kpi-card__header">
        <div class="kpi-card__icon">
          <i class="pi pi-megaphone"></i>
        </div>
        <div class="kpi-card__content">
          <div class="kpi-card__value" *ngIf="!loadingOverview()">
            {{ overview?.overview?.totalPosts ?? 0 }}
          </div>
          <div class="kpi-card__skeleton" *ngIf="loadingOverview()"></div>
          <div class="kpi-card__label">Posts</div>
        </div>
      </div>
    </div>

    <!-- SmartCoins Earned -->
    <div class="kpi-card">
      <div class="kpi-card__header">
        <div class="kpi-card__icon">
          <i class="pi pi-wallet"></i>
        </div>
        <div class="kpi-card__content">
          <div class="kpi-card__value" *ngIf="!loadingSmartCoins()">
            {{ smartCoinOverview?.overview?.totalEarnedEuros ? formatCurrency(smartCoinOverview!.overview.totalEarnedEuros) : '€0,00' }}
          </div>
          <div class="kpi-card__skeleton" *ngIf="loadingSmartCoins()"></div>
          <div class="kpi-card__label">SmartCoins Verdient</div>
        </div>
      </div>
    </div>

    <!-- SmartCoins Redeemed -->
    <div class="kpi-card">
      <div class="kpi-card__header">
        <div class="kpi-card__icon">
          <i class="pi pi-shopping-bag"></i>
        </div>
        <div class="kpi-card__content">
          <div class="kpi-card__value" *ngIf="!loadingSmartCoins()">
            {{ smartCoinOverview?.overview?.totalRedeemedEuros ? formatCurrency(smartCoinOverview!.overview.totalRedeemedEuros) : '€0,00' }}
          </div>
          <div class="kpi-card__skeleton" *ngIf="loadingSmartCoins()"></div>
          <div class="kpi-card__label">SmartCoins Eingelöst</div>
        </div>
      </div>
    </div>

    <!-- Average Order Value -->
    <div class="kpi-card">
      <div class="kpi-card__header">
        <div class="kpi-card__icon">
          <i class="pi pi-chart-bar"></i>
        </div>
        <div class="kpi-card__content">
          <div class="kpi-card__value" *ngIf="!loadingOverview()">
            {{ overview?.overview?.averageOrderValue ? formatCurrency(overview!.overview.averageOrderValue) : '€0,00' }}
          </div>
          <div class="kpi-card__skeleton" *ngIf="loadingOverview()"></div>
          <div class="kpi-card__label">Ø Bestellwert</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Charts Section -->
  <div class="chart-grid">
    <!-- Revenue Chart -->
    <div class="chart-card">
      <div class="chart-card__header">
        <h3 class="chart-card__title">Umsatzentwicklung ({{ selectedPeriod }})</h3>
      </div>
      <div class="chart-card__body">
        <div class="chart-card__loading" *ngIf="!revenueChartLoaded()">
          <i class="pi pi-spin pi-spinner"></i>
        </div>
        <div class="chart-card__empty" *ngIf="revenueChartLoaded() && !revenueChartHasData()">
          <div class="chart-card__empty-icon">
            <i class="pi pi-chart-line"></i>
          </div>
          <div class="chart-card__empty-text">Keine Daten verfügbar</div>
          <div class="chart-card__empty-subtext">Umsatzdaten werden hier angezeigt</div>
        </div>
        <canvas #revenueChart [style.display]="revenueChartHasData() ? 'block' : 'none'"></canvas>
      </div>
    </div>

    <!-- Order Status Chart -->
    <div class="chart-card">
      <div class="chart-card__header">
        <h3 class="chart-card__title">Bestellstatus</h3>
      </div>
      <div class="chart-card__body">
        <div class="chart-card__loading" *ngIf="!orderStatusChartLoaded()">
          <i class="pi pi-spin pi-spinner"></i>
        </div>
        <div class="chart-card__empty" *ngIf="orderStatusChartLoaded() && !orderStatusChartHasData()">
          <div class="chart-card__empty-icon">
            <i class="pi pi-chart-pie"></i>
          </div>
          <div class="chart-card__empty-text">Keine Daten verfügbar</div>
          <div class="chart-card__empty-subtext">Bestellstatus wird hier angezeigt</div>
        </div>
        <canvas #orderStatusChart [style.display]="orderStatusChartHasData() ? 'block' : 'none'"></canvas>
      </div>
    </div>

    <!-- User Growth Chart -->
    <div class="chart-card">
      <div class="chart-card__header">
        <h3 class="chart-card__title">Nutzerwachstum</h3>
      </div>
      <div class="chart-card__body">
        <div class="chart-card__loading" *ngIf="!userGrowthChartLoaded()">
          <i class="pi pi-spin pi-spinner"></i>
        </div>
        <div class="chart-card__empty" *ngIf="userGrowthChartLoaded() && !userGrowthChartHasData()">
          <div class="chart-card__empty-icon">
            <i class="pi pi-users"></i>
          </div>
          <div class="chart-card__empty-text">Keine Daten verfügbar</div>
          <div class="chart-card__empty-subtext">Nutzerwachstum wird hier angezeigt</div>
        </div>
        <canvas #userGrowthChart [style.display]="userGrowthChartHasData() ? 'block' : 'none'"></canvas>
      </div>
    </div>

    <!-- Post Engagement Chart -->
    <div class="chart-card">
      <div class="chart-card__header">
        <h3 class="chart-card__title">Post Engagement</h3>
      </div>
      <div class="chart-card__body">
        <div class="chart-card__loading" *ngIf="!postEngagementChartLoaded()">
          <i class="pi pi-spin pi-spinner"></i>
        </div>
        <div class="chart-card__empty" *ngIf="postEngagementChartLoaded() && !postEngagementChartHasData()">
          <div class="chart-card__empty-icon">
            <i class="pi pi-heart"></i>
          </div>
          <div class="chart-card__empty-text">Keine Daten verfügbar</div>
          <div class="chart-card__empty-subtext">Engagement-Daten werden hier angezeigt</div>
        </div>
        <canvas #postEngagementChart [style.display]="postEngagementChartHasData() ? 'block' : 'none'"></canvas>
      </div>
    </div>

    <!-- SmartCoin Flow Chart -->
    <div class="chart-card chart-card--wide">
      <div class="chart-card__header">
        <h3 class="chart-card__title">SmartCoin Bewegungen</h3>
      </div>
      <div class="chart-card__body">
        <div class="chart-card__loading" *ngIf="!smartCoinFlowChartLoaded()">
          <i class="pi pi-spin pi-spinner"></i>
        </div>
        <div class="chart-card__empty" *ngIf="smartCoinFlowChartLoaded() && !smartCoinFlowChartHasData()">
          <div class="chart-card__empty-icon">
            <i class="pi pi-wallet"></i>
          </div>
          <div class="chart-card__empty-text">Keine Daten verfügbar</div>
          <div class="chart-card__empty-subtext">SmartCoin-Bewegungen werden hier angezeigt</div>
        </div>
        <canvas #smartCoinFlowChart [style.display]="smartCoinFlowChartHasData() ? 'block' : 'none'"></canvas>
      </div>
    </div>
  </div>

  <!-- Summary Cards -->
  <div class="summary-grid">
    <!-- Order Analytics -->
    <div class="summary-card">
      <h4 class="summary-card__title">Bestellungen ({{ selectedPeriod }})</h4>
      <div class="summary-card__list" *ngIf="!loadingOrders() && orderAnalytics">
        <div class="summary-card__row">
          <span class="summary-card__label">Gesamt</span>
          <span class="summary-card__value">{{ orderAnalytics.analytics.totalOrders }}</span>
        </div>
        <div class="summary-card__row">
          <span class="summary-card__label">Umsatz</span>
          <span class="summary-card__value">{{ formatCurrency(orderAnalytics.analytics.totalRevenue) }}</span>
        </div>
        <div class="summary-card__row">
          <span class="summary-card__label">Ø Bestellwert</span>
          <span class="summary-card__value">{{ formatCurrency(orderAnalytics.analytics.averageOrderValue) }}</span>
        </div>
        <div class="summary-card__row">
          <span class="summary-card__label">Kunden</span>
          <span class="summary-card__value">{{ orderAnalytics.analytics.uniqueCustomers }}</span>
        </div>
      </div>
      <div class="kpi-card__skeleton kpi-card__skeleton--tall" *ngIf="loadingOrders()"></div>
    </div>

    <!-- User Analytics -->
    <div class="summary-card">
      <h4 class="summary-card__title">Nutzer</h4>
      <div class="summary-card__list" *ngIf="!loadingUsers() && userAnalytics">
        <div class="summary-card__row">
          <span class="summary-card__label">Gesamt</span>
          <span class="summary-card__value">{{ userAnalytics.analytics.totalUsers }}</span>
        </div>
        <div class="summary-card__row">
          <span class="summary-card__label">Neu ({{ selectedPeriod }})</span>
          <span class="summary-card__value">{{ userAnalytics.analytics.newUsers }}</span>
        </div>
        <div class="summary-card__row">
          <span class="summary-card__label">Aktiv</span>
          <span class="summary-card__value">{{ userAnalytics.analytics.activeUsers }}</span>
        </div>
        <div class="summary-card__row">
          <span class="summary-card__label">Wachstum</span>
          <span class="summary-card__value" [class.summary-card__value--green]="userAnalytics.analytics.growthTrend >= 0" [class.summary-card__value--red]="userAnalytics.analytics.growthTrend < 0">
            {{ userAnalytics.analytics.growthTrend > 0 ? '+' : '' }}{{ userAnalytics.analytics.growthTrend.toFixed(1) }}%
          </span>
        </div>
      </div>
      <div class="kpi-card__skeleton kpi-card__skeleton--tall" *ngIf="loadingUsers()"></div>
    </div>

    <!-- Post Analytics -->
    <div class="summary-card">
      <h4 class="summary-card__title">Posts & Engagement</h4>
      <div class="summary-card__list" *ngIf="!loadingPosts() && postAnalytics">
        <div class="summary-card__row">
          <span class="summary-card__label">Posts</span>
          <span class="summary-card__value">{{ postAnalytics.analytics.totalPosts }}</span>
        </div>
        <div class="summary-card__row">
          <span class="summary-card__label">Likes</span>
          <span class="summary-card__value">{{ postAnalytics.analytics.totalLikes }}</span>
        </div>
        <div class="summary-card__row">
          <span class="summary-card__label">Kommentare</span>
          <span class="summary-card__value">{{ postAnalytics.analytics.totalComments }}</span>
        </div>
        <div class="summary-card__row">
          <span class="summary-card__label">Engagement</span>
          <span class="summary-card__value">{{ postAnalytics.analytics.engagementRate.toFixed(1) }}</span>
        </div>
      </div>
      <div class="kpi-card__skeleton kpi-card__skeleton--tall" *ngIf="loadingPosts()"></div>
    </div>
  </div>

  <!-- Top Business Chart -->
  <div class="chart-grid">
    <div class="chart-card chart-card--wide">
      <div class="chart-card__header">
        <h3 class="chart-card__title">Top Business Hubs nach Umsatz</h3>
      </div>
      <div class="chart-card__body chart-card__body--tall">
        <div class="chart-card__loading" *ngIf="!businessChartLoaded()">
          <i class="pi pi-spin pi-spinner"></i>
        </div>
        <div class="chart-card__empty" *ngIf="businessChartLoaded() && !businessChartHasData()">
          <div class="chart-card__empty-icon">
            <i class="pi pi-building"></i>
          </div>
          <div class="chart-card__empty-text">Keine Daten verfügbar</div>
          <div class="chart-card__empty-subtext">Business Hub Daten werden hier angezeigt</div>
        </div>
        <canvas #businessPerformanceChart [style.display]="businessChartHasData() ? 'block' : 'none'"></canvas>
      </div>
    </div>
  </div>

  <!-- List Cards -->
  <div class="list-grid">
    <!-- Top Business Hubs -->
    <div class="list-card">
      <div class="list-card__header">
        <h3 class="list-card__title">Top Business Hubs</h3>
      </div>
      <div class="list-card__body" *ngIf="!loadingOrders() && orderAnalytics && orderAnalytics.topBusinesses.length > 0">
        <div class="list-card__item" *ngFor="let business of orderAnalytics.topBusinesses">
          <div class="list-card__avatar">
            <img *ngIf="business.avatar" [src]="business.avatar" [alt]="business.name">
            <i *ngIf="!business.avatar" class="pi pi-building"></i>
          </div>
          <div class="list-card__info">
            <div class="list-card__name">{{ business.name }}</div>
            <div class="list-card__meta">
              <i class="pi pi-shopping-cart"></i>
              {{ business.orderCount }} Bestellungen
            </div>
          </div>
          <div class="list-card__amount">{{ formatCurrency(business.revenue) }}</div>
        </div>
      </div>
      <div class="list-card__empty" *ngIf="!loadingOrders() && orderAnalytics && orderAnalytics.topBusinesses.length === 0">
        <i class="pi pi-inbox"></i>
        <p>Keine Daten verfügbar</p>
      </div>
      <div class="kpi-card__skeleton kpi-card__skeleton--list" *ngIf="loadingOrders()"></div>
    </div>

    <!-- Top Posts -->
    <div class="list-card">
      <div class="list-card__header">
        <h3 class="list-card__title">Top Posts</h3>
      </div>
      <div class="list-card__body" *ngIf="!loadingPosts() && postAnalytics && postAnalytics.topPosts.length > 0">
        <div class="list-card__item" *ngFor="let post of postAnalytics.topPosts">
          <div class="list-card__info list-card__info--full">
            <div class="list-card__name list-card__name--wrap">{{ post.content }}</div>
            <div class="list-card__meta">
              <span><i class="pi pi-user"></i> {{ post.author }}</span>
              <span><i class="pi pi-heart"></i> {{ post.likes }}</span>
              <span><i class="pi pi-comment"></i> {{ post.comments }}</span>
            </div>
          </div>
          <div class="list-card__amount">{{ post.engagement }}</div>
        </div>
      </div>
      <div class="list-card__empty" *ngIf="!loadingPosts() && postAnalytics && postAnalytics.topPosts.length === 0">
        <i class="pi pi-inbox"></i>
        <p>Keine Posts verfügbar</p>
      </div>
      <div class="kpi-card__skeleton kpi-card__skeleton--list" *ngIf="loadingPosts()"></div>
    </div>
  </div>

  <!-- SmartCoin & Post Type Summary -->
  <div class="summary-grid summary-grid--two-col">
    <!-- SmartCoin Overview -->
    <div class="summary-card">
      <h4 class="summary-card__title">
        <i class="pi pi-wallet"></i>
        SmartCoins Übersicht
      </h4>
      <div class="summary-card__list" *ngIf="!loadingSmartCoins() && smartCoinOverview">
        <div class="summary-card__row">
          <span class="summary-card__label">Verdient</span>
          <span class="summary-card__value summary-card__value--green">
            {{ formatCurrency(smartCoinOverview.overview.totalEarnedEuros) }}
          </span>
        </div>
        <div class="summary-card__row">
          <span class="summary-card__label">Eingelöst</span>
          <span class="summary-card__value summary-card__value--red">
            {{ formatCurrency(smartCoinOverview.overview.totalRedeemedEuros) }}
          </span>
        </div>
        <div class="summary-card__row">
          <span class="summary-card__label">Netto</span>
          <span class="summary-card__value" [class.summary-card__value--green]="smartCoinOverview.overview.netFlowEuros >= 0" [class.summary-card__value--red]="smartCoinOverview.overview.netFlowEuros < 0">
            {{ formatCurrency(smartCoinOverview.overview.netFlowEuros) }}
          </span>
        </div>
        <div class="summary-card__row">
          <span class="summary-card__label">Im Umlauf</span>
          <span class="summary-card__value">
            {{ formatCurrency(smartCoinOverview.overview.totalCirculationEuros) }}
          </span>
        </div>
      </div>
      <div class="kpi-card__skeleton kpi-card__skeleton--tall" *ngIf="loadingSmartCoins()"></div>
    </div>

    <!-- Post Types -->
    <div class="summary-card">
      <h4 class="summary-card__title">Post Arten</h4>
      <div class="summary-card__list" *ngIf="!loadingPosts() && postAnalytics">
        <div class="summary-card__row" *ngFor="let type of postAnalytics.postTypeBreakdown">
          <span class="summary-card__label">{{ type.type }}</span>
          <span class="summary-card__value">{{ type.count }}</span>
        </div>
      </div>
      <div class="kpi-card__skeleton kpi-card__skeleton--tall" *ngIf="loadingPosts()"></div>
    </div>
  </div>

  <!-- Error State -->
  <div class="error-card" *ngIf="hasError()">
    <i class="pi pi-wifi"></i>
    <h3>Daten konnten nicht geladen werden</h3>
    <p>Bitte überprüfe deine Verbindung und versuche es erneut.</p>
    <button (click)="forceRefresh()">
      <i class="pi pi-refresh"></i>
      Erneut versuchen
    </button>
  </div>
</div>
